import {
  Container,
  Heading,
  Link,
  PinInput,
  Stack,
  Text,
  VStack,
  Button,
  Box,
  Flex,
} from '@chakra-ui/react'
import Logo from '@components/Logo';
import ToggleColorMode from '@components/ToggleColorMode';
import { LuArrowRight } from 'react-icons/lu'

const OtpCode = () => (
  <Flex height="100vh" flex="1">
    <Box position="absolute" top="4" left="4">
      <ToggleColorMode />
    </Box>
    <Container maxW="md" py={{ base: '12', md: '24' }}>
      <Stack gap="8">
        <Flex justifyContent="center">
          <Logo />
        </Flex>
        <Stack gap={{ base: '2', md: '3' }} textAlign="center">
          <Heading>
            Enviamos um código para o seu endereço de e-mail
          </Heading>
          <Text color="fg.muted">
            Insira o código abaixo para continuar
          </Text>
        </Stack>

        <VStack gap="6">
          <PinInput.Root size="xl" placeholder="">
            <PinInput.HiddenInput />
            <PinInput.Control>
              <PinInput.Input index={0} />
              <PinInput.Input index={1} />
              <PinInput.Input index={2} />
              <PinInput.Input index={3} />
              <PinInput.Input index={4} />
              <PinInput.Input index={5} />
            </PinInput.Control>
          </PinInput.Root>
          <Text textStyle="sm" color="fg.muted" textAlign="center">
            Não recebeu o código?{' '}
            <Link variant="underline" href="#">
              Reenviar
            </Link>
          </Text>
        </VStack>

        <Button colorPalette="argos">
          Continuar <LuArrowRight />
        </Button>
      </Stack>
    </Container>
  </Flex>
);

export default OtpCode;
